import { getLoyaltySDK } from "../../api/loyaltySdk";
import { getEventStartAndEndDate, getLiveEvent } from "./eventUtils";
import {
  getLoyaltyConfig,
  hasBenefitAccess,
  getBenefitTypeConfig,
} from "./loyaltySdkUtils";
import { getAdditionalContextFromVariantAndProduct } from "./contextUtils";
import {
  APP_EARLY_ACCESS_SALE,
  EARLY_ACCESS_BENEFIT_TYPE,
} from "../../constants";

const emptyEarlyAccessContext = {
  isEarlyAccessToSale: false,
  earlyAccessToSaleContext: null,
  endDate: null,
};

export const getEarlyAccessToSaleContext = async (product) => {
  const earlyAccessContext = getAdditionalContextFromVariantAndProduct(
    product,
    APP_EARLY_ACCESS_SALE,
  );

  if (!earlyAccessContext) {
    return emptyEarlyAccessContext;
  }

  const loyaltySdk = await getLoyaltySDK();

  const isEligible = await hasBenefitAccess(
    loyaltySdk,
    EARLY_ACCESS_BENEFIT_TYPE,
  );
  if (!isEligible) {
    return emptyEarlyAccessContext;
  }

  const loyaltyConfig = await getLoyaltyConfig(loyaltySdk);
  const earlyAccessConfig = getBenefitTypeConfig(
    loyaltyConfig,
    EARLY_ACCESS_BENEFIT_TYPE,
  );

  if (!earlyAccessConfig) {
    return emptyEarlyAccessContext;
  }

  const earlyAccessEventLive = getLiveEvent(
    earlyAccessConfig?.eventSchedule?.events,
  );

  if (!earlyAccessEventLive) {
    return emptyEarlyAccessContext;
  }

  const { endDate } = getEventStartAndEndDate(earlyAccessEventLive);

  return {
    isEarlyAccessToSale: true,
    earlyAccessToSaleContext: earlyAccessContext,
    endDate,
  };
};
